function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import PropTypes from "prop-types";
import "./card.scss";

const Card = match => {
  const title = match.title,
        titleValue = match.titleValue,
        subtitle = match.subtitle,
        children = match.children,
        className = match.className,
        secondTitle = match.secondTitle,
        secondTitleValue = match.secondTitleValue,
        isCollapsed = match.isCollapsed;

  const _useState = useState(isCollapsed),
        _useState2 = _slicedToArray(_useState, 2),
        collapse = _useState2[0],
        setCollapse = _useState2[1];

  return React.createElement("div", {
    className: "cardBlock " + className
  }, React.createElement("div", {
    className: "cardBlockHeader"
  }, React.createElement("h2", {
    className: "cardBlockTitle"
  }, title, React.createElement("span", {
    className: "cardBlockTitleSecondary"
  }, titleValue)), subtitle && React.createElement("span", {
    className: "cardBlockSubtitle cardBlockSubtitle__indicator"
  }, subtitle), isCollapsed && React.createElement("button", {
    className: "button",
    onClick: () => setCollapse(!collapse)
  }, collapse ? "Expandir" : "Colapsar")), secondTitle && React.createElement("div", {
    className: "cardBlockHeader"
  }, React.createElement("h2", {
    className: "cardBlockTitle"
  }, secondTitle, React.createElement("span", {
    className: "cardBlockTitleSecondary"
  }, secondTitleValue))), React.createElement("div", {
    className: "cardBlockContent ".concat(collapse && "collapse")
  }, children));
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  titleValue: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
Card.defaultProps = {
  titleValue: null,
  subtitle: null
};
export default Card;